import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstanse";

export interface OrderSearchItem {
    display_info: string;
    C_Company: string;
    c_code: string;
    c_company_number: string;
    c_tel: string;
    c_post: string;
    C_ADDR1: string;
    C_ADDR2: string;
    c_no_yn: string;
}

interface OrderSearchResponse {
    statusCode: number;
    message: string;
    data: OrderSearchItem[];
}

export const useGetOrderSearch = (searchText: string, options?: { enabled?: boolean }): UseQueryResult<OrderSearchItem[], Error> => {
    return useQuery({
        queryKey: ["useGetOrderSearch", searchText],
        queryFn: async () => {
            const response = await axiosInstance.get<OrderSearchResponse>(enum_api_uri.order_search, {
                params: { searchText },
            });
            return response.data.data;
        },
        enabled: (options?.enabled ?? true) && searchText.length > 1,
    });
};
